import { useMemo } from "react";

import { useFormContext } from "react-hook-form";

import {
  selectBasicQuestions,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { FormSelectField } from "@covertree/ui";

import {
  getLocationTypes,
  HomeDetailsForm,
} from "../validatorsAndTypes/homeDetailsAndConstructionForm";

interface Props {
  name?: string; // @TODO investigate why "Path" from "react-hook-form" type is not working
  label?: React.ReactNode;
  placeholder?: string;
  tooltip?: string;
  isMyOwnLand?: boolean;
  disabled?: boolean;
  fontSize?: number;
  labelFontSize?: number;
}

export function HomeLocationSelect({
  name = "location",
  label = "Where is your home located?",
  placeholder = "Select...",
  tooltip = "A manufactured home community is a neighborhood designed for manufactured homes. The land may or may not be owned by the homeowners.",
  isMyOwnLand = false,
  disabled,
  fontSize,
  labelFontSize,
}: Props) {
  const { location } = useNewBusinessSelector(selectBasicQuestions);

  const { control } = useFormContext<HomeDetailsForm>();

  const options = useMemo(() => getLocationTypes(isMyOwnLand), [isMyOwnLand]);

  return (
    <FormSelectField
      id="home-location"
      fontSize={fontSize}
      labelFontSize={labelFontSize}
      dataTestId="home-location-input"
      name={name}
      control={control}
      label={location?.label ?? label}
      placeholder={placeholder}
      tooltip={tooltip}
      options={options}
      disabled={disabled}
    />
  );
}
